import { useMemo, useState } from "react";
import Breadcrumb from "@/components/base/Breadcrumb";
import EmptyState from "@/components/base/EmptyState";
import ActorCard from "@/components/feature/ActorCard";
import useSeo from "@/hooks/useSeo";
import { allActors } from "@/lib/content";

export default function ActorsList() {
  useSeo({
    title: "演员介绍 - 主创阵容 | 筱田优官网",
    description: "筱田优影视作品的主创阵容介绍，包含演员与导演的个人资料、代表作品与相关新闻。",
    keywords: "筱田优,演员介绍,主创阵容,影视演员",
  });

  const [keyword, setKeyword] = useState("");

  const filtered = useMemo(() => {
    const q = keyword.trim().toLowerCase();
    if (!q) return allActors;
    return allActors.filter((a) => a.name.toLowerCase().includes(q) || a.bio.toLowerCase().includes(q));
  }, [keyword]);

  return (
    <div className="w-full pt-20 md:pt-24">
      <div className="bg-background-100 border-b border-background-200">
        <div className="w-full px-4 md:px-8 py-8 md:py-10">
          <Breadcrumb items={[{ label: "演员" }]} />
          <h1 className="font-heading text-2xl md:text-4xl font-black text-foreground-950 mt-4">演员介绍</h1>
          <p className="text-sm md:text-base text-foreground-600 mt-3 max-w-2xl leading-relaxed">
            认识与筱田优并肩创作的演员与导演，了解他们在光影背后的故事。
          </p>

          <div className="mt-6 flex items-center gap-2 rounded-full px-4 h-11 bg-background-50 border border-background-200 max-w-md">
            <i className="ri-search-line text-foreground-400" />
            <input
              value={keyword}
              onChange={(e) => setKeyword(e.target.value)}
              placeholder="输入姓名搜索演员 / 导演"
              className="bg-transparent outline-none text-sm flex-1 text-foreground-900 placeholder:text-foreground-400"
            />
            {keyword && (
              <button
                type="button"
                aria-label="清空"
                onClick={() => setKeyword("")}
                className="text-foreground-400 hover:text-foreground-700 cursor-pointer"
              >
                <i className="ri-close-circle-line" />
              </button>
            )}
          </div>
        </div>
      </div>

      <div className="w-full px-4 md:px-8 py-10 md:py-12">
        {filtered.length === 0 ? (
          <EmptyState
            icon="ri-user-search-line"
            title="未找到匹配演员"
            description="没有找到与关键词匹配的人物，换个名字试试吧。"
            onReset={() => setKeyword("")}
          />
        ) : (
          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-5">
            {filtered.map((actor) => (
              <ActorCard key={actor.id} actor={actor} />
            ))}
          </div>
        )}
      </div>
    </div>
  );
}